import { AboutHeroSection, AboutStorySection } from '@/components/sections'

export const AboutPage = () => (
  <main>
    <AboutHeroSection />
    <AboutStorySection />
  </main>
)
